export default "__VITE_ASSET__CIsbf0u0__"